import React, { useState } from 'react';
import { FaTimes, FaPhone, FaWhatsapp, FaUser, FaEnvelope, FaCalendarAlt, FaUsers, FaMapMarkerAlt } from 'react-icons/fa';

const BookingModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    travelers: '',
    dates: '',
    destination: '',
    message: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `Hello! I'm interested in booking a caravan.%0A%0AName: ${formData.name}%0AEmail: ${formData.email}%0APhone: ${formData.phone}%0ANumber of Travelers: ${formData.travelers}%0ATravel Dates: ${formData.dates}%0ADestination: ${formData.destination}%0A%0AMessage: ${formData.message}`;
    window.open(`https://wa.me/918380866111?text=${message}`, '_blank');
    onClose();
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div className="relative w-full max-w-2xl bg-white rounded-3xl shadow-2xl max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 text-gray-500 hover:text-gray-700 transition-colors bg-white rounded-full shadow-lg hover:shadow-xl"
        >
          <FaTimes className="text-xl" />
        </button>

        {/* Header */}
        <div className="bg-gradient-to-r from-primary-600 to-forest-600 text-white p-8 rounded-t-3xl">
          <h2 className="text-3xl font-bold mb-2">Book Your Adventure</h2>
          <p className="text-primary-100">Fill in your details and we'll get back to you shortly</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          <div>
            <label className="block text-primary-700 font-semibold mb-2">
              <FaUser className="inline mr-2" />
              Full Name *
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border-2 border-primary-200 rounded-xl focus:border-accent-500 focus:outline-none transition-colors"
              placeholder="Enter your full name"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-primary-700 font-semibold mb-2">
                <FaEnvelope className="inline mr-2" />
                Email *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 border-primary-200 rounded-xl focus:border-accent-500 focus:outline-none transition-colors"
                placeholder="your.email@example.com"
              />
            </div>

            <div>
              <label className="block text-primary-700 font-semibold mb-2">
                <FaPhone className="inline mr-2" />
                Phone *
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 border-primary-200 rounded-xl focus:border-accent-500 focus:outline-none transition-colors"
                placeholder="+91 98765 43210"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-primary-700 font-semibold mb-2">
                <FaUsers className="inline mr-2" />
                Number of Travelers *
              </label>
              <select
                name="travelers"
                value={formData.travelers}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 border-primary-200 rounded-xl focus:border-accent-500 focus:outline-none transition-colors"
              >
                <option value="">Select...</option>
                <option value="1-2">1-2 People</option>
                <option value="3-4">3-4 People</option>
                <option value="5-6">5-6 People</option>
                <option value="7+">7+ People</option>
              </select>
            </div>

            <div>
              <label className="block text-primary-700 font-semibold mb-2">
                <FaCalendarAlt className="inline mr-2" />
                Travel Dates *
              </label>
              <input
                type="text"
                name="dates"
                value={formData.dates}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 border-primary-200 rounded-xl focus:border-accent-500 focus:outline-none transition-colors"
                placeholder="e.g., March 15-20, 2026"
              />
            </div>
          </div>

          <div>
            <label className="block text-primary-700 font-semibold mb-2">
              <FaMapMarkerAlt className="inline mr-2" />
              Destination (Optional)
            </label>
            <select
              name="destination"
              value={formData.destination}
              onChange={handleChange}
              className="w-full px-4 py-3 border-2 border-primary-200 rounded-xl focus:border-accent-500 focus:outline-none transition-colors"
            >
              <option value="">Select destination...</option>
              <option value="Goa">Goa Beaches</option>
              <option value="Ladakh">Ladakh Mountains</option>
              <option value="Rajasthan">Rajasthan Desert</option>
              <option value="Kerala">Kerala Backwaters</option>
              <option value="Custom">Custom Route</option>
            </select>
          </div>

          <div>
            <label className="block text-primary-700 font-semibold mb-2">
              Additional Message
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              className="w-full px-4 py-3 border-2 border-primary-200 rounded-xl focus:border-accent-500 focus:outline-none transition-colors resize-none"
              placeholder="Tell us about your dream journey..."
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-accent-500 to-accent-600 text-white py-4 rounded-xl font-bold text-lg hover:from-accent-600 hover:to-accent-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center space-x-2"
          >
            <FaWhatsapp className="text-2xl" />
            <span>Send via WhatsApp</span>
          </button>

          <p className="text-center text-sm text-primary-600">
            You can also call us directly at{' '}
            <a href="tel:+918380866111" className="font-semibold text-accent-600 hover:text-accent-700">
              +91 83808-66111
            </a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default BookingModal;
